import { useEffect, useState } from "react";
import { motion } from "motion/react";
import { Box, Text } from "@/ui";

const CHARACTER_DELAY = 0.02;
const CHARACTER_ANIMATION_DURATION = 0.3;

export default function AnimatedStepText({ text }: { text: string }) {
  const [visibleChars, setVisibleChars] = useState(0);
  const characters = Array.from(text);

  useEffect(() => {
    setVisibleChars(0);

    const intervalId = setInterval(() => {
      setVisibleChars((prev) => {
        if (prev >= characters.length) {
          clearInterval(intervalId);
          return prev;
        }

        const next = prev + 1;
        if (next >= characters.length) clearInterval(intervalId);
        return next;
      });
    }, CHARACTER_DELAY * 1000);

    return () => clearInterval(intervalId);
  }, [characters.length]);

  return (
    <Box position="relative" display="inline-block">
      <Text color="on-surface-variant" whiteSpace="pre" visibility="hidden">
        {text}
      </Text>
      <Text color="on-surface-variant" whiteSpace="pre" position="absolute" left={0} top={0}>
        {characters.map((character, index) => (
          <motion.span
            key={`${text}-${index}`}
            style={{ display: "inline-block" }}
            initial={false}
            animate={{ opacity: index < visibleChars ? 1 : 0 }}
            transition={{
              duration: CHARACTER_ANIMATION_DURATION,
              ease: "easeInOut"
            }}
          >
            {character}
          </motion.span>
        ))}
      </Text>
    </Box>
  );
}
